<template>
  <div class="legal-layout">
    <div class="legal-layout__inner">
      <h1 class="legal-layout__title">{{ title }}</h1>
      <div class="legal-layout__content">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'LegalContentLayout',
  props: {
    title: {
      type: String,
      default: ''
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/css/variables.scss';

.legal-layout {
  padding: rem(60) rem(180);

  &__inner {
    border-left: 1px solid rgba(0, 0, 0, 0.1);
    border-right: 1px solid rgba(0, 0, 0, 0.1);
    background: linear-gradient(180deg, rgba(0, 0, 0, 0.1) 0%, rgba(0, 0, 0, 0) 100%);
    padding: rem(60);
    display: flex;
    flex-direction: column;
    gap: rem(40);
  }

  &__title {
    margin: 0;
    color: #000;
    font-family: $font-family-serif;
    font-size: rem(24);
    font-weight: 700;
    line-height: rem(24);
  }

  &__content {
    color: #000;
    font-family: $font-family-serif;
    font-size: rem(12);
    font-weight: 400;
    line-height: rem(24);
  }
}

.legal-layout :deep(h2),
.legal-layout :deep(h3) {
  margin: rem(8) 0;
  color: #000;
  font-family: $font-family-serif;
  font-size: rem(16);
  font-weight: 400;
  line-height: rem(24);
}

.legal-layout :deep(p) {
  margin: 0;
  color: #000;
  font-family: $font-family-serif;
  font-size: rem(12);
  font-weight: 400;
  line-height: rem(24);
}

.legal-layout :deep(ul),
.legal-layout :deep(ol) {
  margin: 0;
  padding-left: rem(20);
}

.legal-layout :deep(li) {
  margin: 0;
  color: #000;
  font-family: $font-family-serif;
  font-size: rem(12);
  font-weight: 400;
  line-height: rem(24);
}

.legal-layout :deep(a) {
  color: #000;
  text-decoration: underline;
}

.detect_deviece_mobile {
  .legal-layout {
    padding: rem(24) rem(16);

    &__inner {
      padding: rem(24) rem(16);
      gap: rem(20);
    }

    &__title {
      font-size: rem(22);
      line-height: rem(24);
    }
  }

  .legal-layout :deep(h2),
  .legal-layout :deep(h3) {
    font-size: rem(15);
    line-height: rem(22);
  }

  .legal-layout :deep(p),
  .legal-layout :deep(li) {
    font-size: rem(12);
    line-height: rem(22);
  }
}
</style>
